import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'reactstrap'
import { Modal } from "react-bootstrap";
import { toast } from 'react-toastify';
import { searchTransactions } from '../../stores/services/transactions.service';
import ViewTransaction from "../view-beta-txn";
import { getAccountByAccountCode } from '../../stores/services/account.service';


function ViewInvesterRequest(props) {
    const {
        selectedItem,
        viewTXNDetailsCardObj
    } = props

    const [showViewTxnModal, setShowViewTxnModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<any>([])
    const [ourBankDetails, setOurBankDetails] = useState<any>([])
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";

    const handleViewTxn = async (valueIs = "") => {
        setLoading(true)
        try {
            let res = await searchTransactions(
                email,
                amc_code,
                "",
                "",
                valueIs ? valueIs : selectedItem?.related_txn_id,
                "",
                // selectedItem?.request_type
                ""
            )
            if (res.status === 200 && res?.data?.status === 200) {
                setData(res.data.data[0])
                sessionStorage.setItem("TxnData", JSON.stringify(res.data.data[0]))
                setShowViewTxnModal(true)
            }
        } catch (error) {
            toast.error(`No Corresponding TXN found for ${selectedItem?.related_txn_id}`)
            setLoading(false)
        }
    }

    useEffect(() => {
        const BankByCode = async () => {
            try {
                let res = await getAccountByAccountCode(
                    email,
                    amc_code,
                    selectedItem?.bank_account_code
                )
                if (res.status === 200 && res.data.status === 200) {
                    setOurBankDetails(res?.data?.data)
                }
                else {
                    setOurBankDetails([])
                }
            }
            catch (error) {
                setOurBankDetails([])
            }
        }
        if (!selectedItem?.conversion_in_txn_id) {
            BankByCode()
        }
    }, [])

    const getDataFormat = (checkDate) => {
        return moment(checkDate).format(
            "DD-MM-YYYY, h:mm a"
        ) == "Invalid date" ? "" : moment(checkDate).format(
            "DD-MM-YYYY, h:mm a"
        )
    }

    const renderConversionCard = () => {
        return (
            <>

                <div className='card'>
                    <div className='card-header'>
                        ConversionOut
                    </div>
                    <div className='card-body'>
                        <Row>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Fund</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.fund_code}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Price</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.investor_bank_iban}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Units</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.units_requested}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Conversion Amount</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.gross_amount_limit}
                                        disabled
                                    />
                                </div>
                            </Col>

                        </Row>
                    </div>


                </div>

                <div className='card'>
                    <div className='card-header'>
                        ConversionIn
                    </div>
                    <div className='card-body'>
                        <Row>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Fund</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.convert_fund_code}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Price</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.investor_bank_iban}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Units</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.convert_units_requested}
                                        disabled
                                    />
                                </div>
                            </Col>
                            {/* <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Gross Amount</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.gross_amount_limit}
                                        disabled
                                    />
                                </div>
                            </Col> */}

                        </Row>
                    </div>

                </div>

            </>
        )
    }

    return (
        <>
            {/* ---------------- View Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={showViewTxnModal ? true : false}
                size="xl"
                backdrop={true}
                onHide={() => {
                    setShowViewTxnModal(false);
                    setData([])
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setShowViewTxnModal(false);
                            setData([])
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">
                        View Related TXN
                    </h6>
                </div>
                <div className="modal-body">
                    <ViewTransaction data={data} />
                </div>
            </Modal>
            <Col className='px-0'>
                <div className='card'>
                    <div className='card-header'>
                        Request Details
                    </div>
                    <div className='card-body'>
                        <Row>
                            {selectedItem?.request_type !== "conversionofunits" && <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Fund Code</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.fund_code}
                                        disabled
                                    />
                                </div>
                            </Col>}
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Folio No</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.folio_no}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Requested Type</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.request_type}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Requested Status</label>
                                    <input
                                        className="form-control"
                                        value={selectedItem?.request_status}
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="form-group">
                                    <label>Requested Time</label>
                                    <input
                                        className="form-control"
                                        value={moment(selectedItem?.request_time)?.format("DD-MM-YYYY")}
                                        disabled
                                    />
                                </div>
                            </Col>
                            {selectedItem?.request_type !== "conversionofunits" &&
                                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                    <div className="form-group">
                                        <label>Unit Requested</label>
                                        <input
                                            className="form-control"
                                            value={selectedItem?.units_requested}
                                            disabled
                                        />
                                    </div>
                                </Col>}
                        </Row>
                    </div>

                </div>

                {selectedItem?.request_type !== "conversionofunits" ?
                    <>
                        <div className='card'>
                            <div className='card-header'>
                                Payment Details
                            </div>
                            <div className='card-body'>
                                <Row>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Fund Code</label>
                                            <input
                                                className="form-control"
                                                value={selectedItem?.fund_code}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Payment Status</label>
                                            <input
                                                className="form-control"
                                                value={selectedItem?.payment_status}
                                                disabled
                                            />
                                        </div>
                                    </Col>

                                    {selectedItem?.payment_proof &&
                                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <div className="form-group d-flex flex-column">
                                                <label>Payment Proof</label>
                                                <img
                                                    style={{
                                                        width: "200px",
                                                        height: "200px",
                                                        objectFit: "contain",
                                                        objectPosition: "center"
                                                    }}
                                                    src={selectedItem?.payment_proof}
                                                />
                                            </div>
                                        </Col>}

                                </Row>
                            </div>

                        </div>

                        <div className='card'>
                            <div className='card-header'>
                                {selectedItem?.request_type === "redemptionofunits" ? "Payee Details" : "Payer Details"}
                            </div>
                            <div className='card-body'>
                                <Row>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Account Title</label>
                                            <input
                                                className="form-control"
                                                value={selectedItem?.investor_account_title}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>IBAN</label>
                                            <input
                                                className="form-control"
                                                value={selectedItem?.investor_bank_iban}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Bank Name</label>
                                            <input
                                                className="form-control"
                                                value={selectedItem?.investor_bank_name}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Branch Name</label>
                                            <input
                                                className="form-control"
                                                value={selectedItem?.investor_branch_name}
                                                disabled
                                            />
                                        </div>
                                    </Col>

                                </Row>
                            </div>

                        </div>

                        <div className='card'>
                            <div className='card-header'>
                                {selectedItem?.request_type === "redemptionofunits" ? "Payer Details" : "Payee Details"}
                            </div>
                            <div className='card-body'>
                                <Row>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Account Title</label>
                                            <input
                                                className="form-control"
                                                value={ourBankDetails?.account_title}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>IBAN</label>
                                            <input
                                                className="form-control"
                                                value={ourBankDetails?.account_no}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Bank Name</label>
                                            <input
                                                className="form-control"
                                                value={ourBankDetails?.bank_name}
                                                disabled
                                            />
                                        </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <div className="form-group">
                                            <label>Branch Name</label>
                                            <input
                                                className="form-control"
                                                value={ourBankDetails?.branch_name}
                                                disabled
                                            />
                                        </div>
                                    </Col>

                                </Row>
                            </div>

                        </div>
                    </> :
                    renderConversionCard()
                }

                <div className="line"></div>
                <Row className=" pb-0">
                    {
                        Object?.entries(viewTXNDetailsCardObj)
                            ?.filter(([key, value]) => value)
                            ?.sort((a, b) => {
                                const order = selectedItem?.request_type === "redemptionofunits" ? [
                                    "created",
                                    "payment_submitted",
                                    "payment_rejected",
                                    "accepted_Requests",
                                    "payment_verified",
                                    "rejected_Requests"
                                ] : [
                                    "created",
                                    "payment_submitted",
                                    "payment_rejected",
                                    "payment_verified",
                                    "accepted_Requests",
                                    "rejected_Requests"
                                ];
                                return order?.indexOf(a[0]) - order?.indexOf(b[0]);
                            })?.map(([key, value]) => {
                                return (
                                    <Col md="3" key={key}>
                                        <div className="card process-card pointer">
                                            <div className="card-header">
                                                <h4 className="card-title">
                                                    <i className="tim-icons icon-single-02 mr-1"></i>
                                                </h4>
                                            </div>
                                            <div className="card-body text-center">
                                                <p className="small mt-2 text-primary">Status:</p>
                                                <h3 className="accepted text-primary">
                                                    {
                                                        key === "created" ? "Created" :
                                                            key === "payment_submitted" ? "Accepted" :
                                                                key === "payment_rejected" ? "Payment Rejected" :
                                                                    key === "payment_verified" ? "Payment Verified" :
                                                                        key === "accepted_Requests" ? "Accepted Request" :
                                                                            "Rejected Request"
                                                    }
                                                </h3>
                                                <p className="small mt-2 text-primary">by</p>
                                                <h4 className="comment text-primary">
                                                    {
                                                        key === "created" ? selectedItem?.requested_by_email :
                                                            key === "payment_submitted" ? selectedItem?.requested_by_email :
                                                                key === "payment_rejected" ? selectedItem?.payment_verified_by :
                                                                    key === "payment_verified" ? selectedItem?.payment_verified_by :
                                                                        key === "accepted_Requests" ? selectedItem?.accepted_by :
                                                                            selectedItem?.rejected_by
                                                    }
                                                </h4>
                                                <p className="small mt-2 text-primary">at</p>
                                                <h4 className="comment text-primary">
                                                    {
                                                        key === "created" ? getDataFormat(selectedItem.creation_time) :
                                                            key === "payment_submitted" ? getDataFormat(selectedItem.creation_time) :
                                                                key === "payment_rejected" ? getDataFormat(selectedItem.payment_verified_date) :
                                                                    key === "payment_verified" ? getDataFormat(selectedItem.payment_verified_date) :
                                                                        key === "accepted_Requests" ? getDataFormat(selectedItem.accepted_date) :
                                                                            getDataFormat(selectedItem.rejected_date)
                                                    }
                                                </h4>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })
                    }
                </Row>

                {(selectedItem?.related_txn_id || selectedItem?.conversion_in_txn_id) &&
                    <div className='card'>
                        <div className='card-header'>
                            Txn Details
                        </div>
                        <div className='card-body'>
                            <Row>
                                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                    <Button
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            if (selectedItem?.related_txn_id) {
                                                handleViewTxn()
                                            }
                                        }}
                                    >
                                        {
                                            selectedItem?.conversion_in_txn_id || selectedItem?.request_type == "conversionofunits" ?
                                                "ConversionOut TXN" : "Transaction ID"
                                        }
                                    </Button>
                                </Col>
                                {selectedItem?.request_type == "conversionofunits" && selectedItem?.conversion_in_txn_id &&
                                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                        <Button
                                            style={{
                                                cursor: "pointer"
                                            }}
                                            onClick={() => {
                                                if (selectedItem?.conversion_in_txn_id) {
                                                    handleViewTxn(selectedItem?.conversion_in_txn_id)
                                                }
                                            }}
                                        >
                                            ConversionIn TXN
                                        </Button>
                                    </Col>}

                            </Row>
                        </div>

                    </div>}
            </Col>
        </>
    )
}

export default ViewInvesterRequest